import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=4321a16e&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4321a16e')) {
      api.createRecord('4321a16e', component.options)
    } else {
      api.reload('4321a16e', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=4321a16e&", function () {
      api.rerender('4321a16e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yB17zVejxfka/JS/offershelp.vue"
export default component.exports